import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
// @flow
import { BODY_ID, HAS_WINDOW } from '../constants';
var cachedY = 0;
var bodyRef;
var overlayCaller = [];
/**
 * Call when opening a fullscreen overlay. This will lock the screen and shift the {@link BODY_ID} element down to where the body was scrolled. This is necessary to prevent scroll while the overlay is active, and not make the page scroll to top. This will only work when {@link BODY_ID} has been configured as the wrapper element of the content.
 * @param caller
 */

export var initFullscreenOverlay = function initFullscreenOverlay(caller) {
  bodyRef = document.getElementById(BODY_ID);

  if (bodyRef) {
    if (overlayCaller.length === 0) {
      cachedY = window.scrollY || window.pageYOffset;
      toggleLock(true);
      bodyRef.style.transform = "translateY(-".concat(cachedY, "px)");
    }

    if (!overlayCaller.includes(caller)) overlayCaller = [].concat(_toConsumableArray(overlayCaller), [caller]);
  }
};
export var closeFullscreenOverlay = function closeFullscreenOverlay(caller) {
  var pageToTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  bodyRef = document.getElementById(BODY_ID);

  if (bodyRef) {
    if (overlayCaller.length === 0) return;

    if (overlayCaller.includes(caller)) {
      overlayCaller = overlayCaller.filter(function (id) {
        return id !== caller;
      });
    }

    if (overlayCaller.length === 0) {
      toggleLock(false);
      bodyRef.style.transform = 'unset';

      if (pageToTop) {
        cachedY = 0;
      } else if (cachedY !== 0) {
        setTimeout(function () {
          window.scrollTo(0, cachedY);
          cachedY = 0;
        }, 1);
      }

      overlayCaller = [];
    }
  }
};
export var clearFullscreenOverlayCachedY = function clearFullscreenOverlayCachedY() {
  cachedY = 0;
};
/**
 * Fixes the body in order to prevent scroll while a fullscreen overlay is active
 * @param lock
 */

export var toggleLock = function toggleLock(lock) {
  if (HAS_WINDOW) {
    var _document = document,
        body = _document.body,
        documentElement = _document.documentElement;
    body.style.overflowY = lock ? 'hidden' : '';
    body.style.height = lock ? '100%' : '';
    body.style.width = lock ? '100%' : '';
    body.style.position = lock ? 'fixed' : '';
    documentElement.style.overflowY = lock ? 'hidden' : '';
    documentElement.style.height = lock ? '100%' : '';
    documentElement.style.position = lock ? 'fixed' : '';
    documentElement.style.width = lock ? '100%' : '';
  }
};